import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { getFormatValues } from '../../../../lib/utils';

import styles from '../../../../../styles/guest/sections/content/splash.module.scss';

const propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    active: false,
    className: null,
};

const Splash = ({ active, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.active]: active,
            },
        ])}
    >
        <div className={styles.content}>
            <h2>
                <FormattedMessage
                    defaultMessage="Big{nbsp}stories meet{nbsp}small screens"
                    description="Guest content - splash title"
                    values={getFormatValues()}
                />
            </h2>
            <p>
                <FormattedMessage
                    defaultMessage="A mobile editorial format that lives up to your creativity."
                    description="Guest content - splash description"
                    values={getFormatValues()}
                />
            </p>
        </div>
    </div>
);

Splash.propTypes = propTypes;
Splash.defaultProps = defaultProps;

export default Splash;
